<template>
    <div>
        <!-- Begin:PageContent:Main -->
        <section id="content" class="image-bg4">
            <div class="container">
                <div class="row">
                    <div class="alert alert-help">
                        {{ alertmessage[getCurrentLocale] }}
                        <span class="close"></span>
                    </div>

                    <!-- Begin:Content-FlightSearchTabs-Booking -->
                    <div id="main" class="col-sm-8 col-md-9">
                        <sdr-shared-flightsearch-tabs modulo="rebooking"></sdr-shared-flightsearch-tabs>
                    </div>
                    <!-- Begin:Content-FlightSearchTabs-Booking -->

                    <!-- Begin:Content-SideBar-Booking -->
                    <div class="sidebar col-sm-4 col-md-3">
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- End:Content-SideBar-Booking -->
                </div>
            </div>
        </section>
        <!-- End:PageContent:Main -->


        <!-- Begin:Content:RebookingBookingnoOverview -->
        <sdr-rebooking-bookingnooverview modulo="rebooking"></sdr-rebooking-bookingnooverview>
        <!-- End:Content:RebookingBookingnoOverview -->


        <!-- Begin:PromoBox -->
        <sdr-promobox-sundair-app></sdr-promobox-sundair-app>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import FlightSearchTabs from '../shared/flightsearch/FlightSearchTabs.vue'; // Entire Tabs Construct (shared)
    import RebookingBookingnoOverview from './pagecontent/BookingnoOverview.vue';

    import ContactBox from '../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBoxSundairApp from '../booking/pagecontent/PromoBoxSundairApp.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tabs': FlightSearchTabs,
            'sdr-rebooking-bookingnooverview': RebookingBookingnoOverview,

            'sdr-contact-box': ContactBox,
            'sdr-promobox-sundair-app': PromoBoxSundairApp,

        }, // eo components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                alertmessage: {
                    en: 'Info: Dear passenger, here you can only rebook your already booked flights.',
                    de: 'Info: Sehr geehrter Fluggast, hier können Sie ausschließlich Ihre bereits gebuchten Flüge umbuchen.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters(['getCurrentLocale']),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
		mounted: function () {

            let me = this;

            // >>> Render Modal ---------------------------
            // me.$modal.show('news-modal', {}); // Off fot the Moment

        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

        }, // eo methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .alert.alert-help {
        background: #ffdb9a;
        color: #2d3e52;
        margin-left: 15px;
        margin-right: 15px;
    }
    .alert .close,
    .info-box .close {
        color: #2d3e52;
    }
</style>



// WEBPACK FOOTER //
// src/components/rebooking/Home.vue